const courses = [
  {
    id: 1,
    title: "Securing React Apps with Auth0",
    slug: "react-auth0-authentication-security",
    authorId: 1,
    category: "JavaScript"
  },
  {
    id: 2,
    title: "React: The Big Picture",
    slug: "react-big-picture",
    authorId: 1,
    category: "JavaScript"
  },
  {
    id: 3,
    title: "Creating Reusable React Components",
    slug: "react-creating-reusable-components",
    authorId: 1,
    category: "JavaScript"
  },
  {
    id: 4,
    title: "Building a JavaScript Development Environment",
    slug: "javascript-development-environment",
    authorId: 1,
    category: "JavaScript"
  },
  {
    id: 5,
    title: "Building Applications with React and Redux",
    slug: "react-redux-react-router-es6",
    authorId: 1,
    category: "JavaScript"
  },
  {
    id: 6,
    title: "Building Applications in React and Flux",
    slug: "react-flux-building-applications",
    authorId: 1,
    category: "JavaScript"
  },
  {
    id: 7,
    title: "Clean Code: Writing Code for Humans",
    slug: "writing-clean-code-humans",
    authorId: 1,
    category: "Software Practices",
    date: "Fri Jan 24 2025"
  },
  {
    id: 8,
    title: "Architecting Applications for the Real World",
    slug: "architecting-applications-dotnet",
    authorId: 1,
    category: "Software Architecture",
    date: "Fri Jan 24 2025"
  },
  {
    id: 9,
    title: "Becoming an Outlier: Reprogramming the Developer Mind",
    slug: "career-reboot-for-developer-mind",
    authorId: 1,
    category: "Career"
  },
  {
    id: 10,
    title: "Web Component Fundamentals",
    slug: "web-components-shadow-dom",
    authorId: 1,
    category: "HTML5",
    date: "Fri Jan 17 2025"
  }
];

const authors = [
  { id: 1, name: "Cory House" },
  { id: 2, name: "Scott Allen" },
  { id: 3, name: "Dan Wahlin" }
];

const cities = [
  { label: "Malmö", value: "Malmö" },
  { label: "Örebro", value: "Örebro" }
];

const newCourse = {
  id: null,
  title: "",
  authorId: null,
  category: ""
};

const events = [
  {
    id: 1,
    name: "samling",
    address: "ett ställe",
    initiator: 1,
    link: "http://enhemsida.typ",
    city: "Malmö",
    starttime: "2024-10-04 18:55:00",
    endtime: "2024-10-04 18:55:00",
    description: "varchar(1000) DEFAULT NULL",
    targetgroups: ["barn", "unga", "gamla", "trötta"],
    categories: ["lek", "sång", "dans"],
    food: { food: ["fika", "frukost", "middag"], cost: "bjuds" },
    registration_needed: 1,
    registration_info: "some info",
    cost: 200,
    deleted: 0
  },
  {
    id: 2,
    name: "en annan samling",
    address: "ett ställe",
    initiator: 1,
    link: "http://enhemsida.typ",
    city: "Malmö",
    starttime: "2025-01-28 18:55:00",
    endtime: "2025-01-04 18:55:00",
    description: "varchar(1000) DEFAULT NULL",
    targetgroups: ["barn", "unga", "gamla", "trötta"],
    categories: ["lek", "sång", "dans"],
    food: { food: ["fika", "frukost", "middag"], cost: "bjuds" },
    registration_needed: 1,
    registration_info: "some info",
    cost: 200,
    deleted: 0
  },
  {
    id: 3,
    name: "en tredje samling",
    address: "ett ställe",
    initiator: 1,
    link: "http://enhemsida.typ",
    city: "Malmö",
    starttime: "2025-02-04 18:55:00",
    endtime: "2025-02-04 18:55:00",
    description: "varchar(1000) DEFAULT NULL",
    targetgroups: ["barn", "unga", "gamla", "trötta"],
    categories: ["lek", "sång", "dans"],
    food: { food: ["fika", "frukost", "middag"], cost: "bjuds" },
    registration_needed: 1,
    registration_info: "some info",
    cost: 200,
    deleted: 0
  }
];

const newEvent = {
  id: null,
  name: "",
  address: "",
  city: ""
};

// Using CommonJS style export so we can consume via Node (without using Babel-node)
module.exports = {
  newCourse,
  courses,
  authors,
  cities,
  events,
  newEvent
};
